export default __webpack_public_path__ + "73ef8d4d60b6e1297a7ee6b66b26008e.png";